"use strict";
var fails = require("../internals/fails");
module.exports = fails(function() {
  if (typeof ArrayBuffer == "function") {
    var buffer = new ArrayBuffer(8);
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", { value: 8 });
  }
});
